import { ErrorType } from '@/lib/error-type';
import { RefreshTokenError, UnauthenticatedError } from '@/lib/handle-error';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const logErrorToSentry = (error: ErrorType, moreStack: string | undefined) => {
  const formattedError = new Error(error.message);
  formattedError.stack = `${error?.stack} \n ${moreStack}`;
  formattedError.name = error.name;

  Sentry.captureException(formattedError, {
    extra: {
      type: error.name,
      cause: error.cause,
    },
  });
};

export function TanStackQueryProvider(props: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
            throwOnError: (error: any) => {
              logErrorToSentry(error, Error().stack);
              if (error instanceof UnauthenticatedError) {
                navigate('/logout');
              }
              if (error instanceof RefreshTokenError) {
                navigate('/logout');
              }
              return false;
            },
          },
          mutations: {
            throwOnError: (error: any) => {
              logErrorToSentry(error, Error().stack);
              if (error instanceof UnauthenticatedError) {
                navigate('/logout');
              }
              if (error instanceof RefreshTokenError) {
                navigate('/logout');
              }
              return false;
            },
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
